import { useQuery } from '@tanstack/react-query';

import QUERY_KEYS from '../query/queryKeys';
import { fetchUserProjectAccess } from '../modules/users';

import { useUser } from '../context/UserContext';
import { useProject } from '../context/ProjectContext';

export const useRole = () => useUser().role;
export const useProjectRole = () => useProject().projectRole;

export const useUserAccess = () => {
  const { data: userAccess, isLoading, isError, error } = useQuery({
    queryKey: QUERY_KEYS.users.projectAccess(),
    queryFn: fetchUserProjectAccess,
  });

  const {
    is_full_access: isFullAccess = false,
    is_executive_manager: isExecutiveManager = false,
    is_project_admin: isProjectAdmin = false,
    project_ids: projectIds = [],
  } = userAccess || {};

  return {
    isFullAccess,
    isExecutiveManager,
    isProjectAdmin,
    projectIds,
    canSeeAllDefects: isFullAccess || isExecutiveManager || isProjectAdmin,
    error,
    isError,
    isLoading,
  };
};